import { ClipLoader } from 'react-spinners';

const Spinner = ({ loading, color }: { loading: boolean, color: string }) => (
  <div className='spinner'>
    <ClipLoader color={color} loading={loading} size={100} />
  </div>
)

export default Spinner